import classNames from 'classnames';
import { useState, useEffect } from 'react';


// Format time for display
const formatTime = (timeLeft) => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

const ClockSvg = () => (
    <svg className="text-gray-500 w-3.5 h-3.5" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 4V8L10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const LimitedOfferHeader = () => {
    const [timeLeft, setTimeLeft] = useState(1200); // 20 minutes in seconds

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimeLeft((prevTime) => {
                if (prevTime <= 0) {
                    clearInterval(countdown);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);

        return () => clearInterval(countdown);
    }, []);

    return (
        <header className="text-center pt-8 pb-6 px-6">
            <h1 className="text-3xl font-bold text-[#001C3D] mb-4">Start your 7-day free trial</h1>

            <div className="p-3 max-w-xs mx-auto">
                <div className="flex items-center justify-center gap-3">
                    <div className="text-gray-700 text-sm font-medium">Limited offer for:</div>
                    <div className="flex items-center gap-1.5">
                        <ClockSvg />
                        <span className="text-gray-900 font-semibold text-sm tracking-wider">
                            {formatTime(timeLeft)}
                        </span>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default LimitedOfferHeader; 